export function getPosition(e) {
  let xPosition = 0;
  let yPosition = 0;
  let element = e;

  while (element) {
    xPosition += element.offsetLeft - element.scrollLeft + element.clientLeft;
    yPosition += element.offsetTop - element.scrollTop + element.clientTop;
    element = element.offsetParent;
  }

  return { x: xPosition, y: yPosition };
}



// WEBPACK FOOTER //
// ./webpack/lib/utils/dom.js